var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('h2',{staticStyle:{"text-align":"center","margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2260da6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/news-detail.vue
// module id = null
// module chunks = 